import React, { useState } from "react";
import Headroom from "react-headroom";
import { IoMenuOutline, IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";

const Header = ({ scrollToAbout, scrollToProductsandService }) => {
  const [show, setShow] = useState(false);

  const handleClick = () => {
    setShow(!show);
  };

  const handleNavClick = () => {
    setShow(false);
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    handleNavClick(); // Close the menu after scrolling
  };

  return (
    <>
      {show && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[1]"
          onClick={handleNavClick}
        />
      )}
      <Headroom>
        <div className="w-full text-[#fff] bg-[#38761d] font-semibold relative">
          <div className="w-[90%] py-1 mx-auto flex items-center justify-between">
            <Link to={"/"} className="flex items-center">
              <img
                src="/logowithrmbg.png"
                alt=""
                className="md:w-[70px] md:h-[70px] w-[50px] h-[50px]"
              />
            </Link>
            <button className="lg:hidden flex" onClick={handleClick}>
              {!show ? <IoMenuOutline size={30} /> : <IoClose size={30} />}
            </button>

            <div
              className={`lg:flex lg:items-center flex-col lg:static absolute top-[55px] md:top-[63px] lg:bg-transparent bg-[#38761d] lg:p-0 p-4 lg:w-fit w-[50%] right-0 lg:flex-row justify-between gap-6 ${
                show ? "flex flex-col z-20" : "hidden"
              }`}
            >
              <Link
                className="lg:hover:underline uppercase"
                onClick={() => {
                  scrollToAbout();
                  handleNavClick();
                }}
              >
                About Us
              </Link>
              <Link
                className="lg:hover:underline uppercase"
                onClick={() => {
                  scrollToProductsandService();
                  handleNavClick();
                }}
              >
                Our Solution
              </Link>
              <Link
                to={"/blogs-and-news"}
                className="lg:hover:underline uppercase"
                onClick={handleNavClick}
              >
                Blogs
              </Link>
              <Link
                className="lg:hover:underline uppercase"
                onClick={scrollToBottom}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </Headroom>
    </>
  );
};

export default Header;
